import Sedan from "./Sedan";

export default Sedan;